<template>
  <div type="card-full" style="margin: 20px 30px">
    <div class="view-container">
      <div class="view-box">
        <div class="view-row">
          <div class="view-field">
            <div class="view-label">成交确认函</div>
            <div class="view-filelist" v-if="appendList && appendList.length">
              <div
                v-for="(item, index) in appendList"
                :key="index"
                class="view-fileitem"
              >
                <div class="view-filename" @click="downFile(item.appendurl)">
                  <a :src="uploadAddr + item.appendurl">{{
                    item.appendfilename | toolongOmitted
                  }}</a>
                </div>
              </div>
            </div>
            <div v-else class="view-value">无</div>
          </div>
        </div>
        <div>
          <div style="width:100%" v-html="project.projectconfirmletter">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import request from "@/utils/request";
import common from "@/mixin/common";
export default {
  name: "confirmLetterFile",
  mixins: [common],
  data() {
    return {
      appendList: [],
      project:{}
    };
  },
  created() {},
  filters: {},
  async mounted() {
    await this.getModel();
    await this.getProjectInfo()
  },
  watch: {
    "$route.query.Ptype": async function (newVal, oldVal) {
      if (newVal != oldVal) {
        await this.getModel();
      }
    },
  },
  methods: {
    async getModel() {
      let res = await request({
        method: "get",
        url: "/ywgl/append/getAppendListByFromId",
        params: {
          appendfromid: this.$route.query.projectid,
          appendfromtype: 23,
        },
      });
      this.appendList = res;
    },
    async getProjectInfo() {
      this.loading = true;
      let res = await request({
        method: "get",
        url: "/xmgl/project/getProjectById",
        params: { projectid: this.$route.query.projectid },
      });
      this.project = res[0];
      this.loading = false;
    },
  },
  computed: {
    uploadAddr() {
      return this.$store.getters.uploadAddr;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../styles/table.scss";
</style>
